import React, { useState, useEffect } from "react";
import {
  getBio,
  updateBioCreator,
  updateCreatorImage,
  getSpecificCreator,
  updateCreatorBanner
} from "../../service/api";
import { FaSpinner } from "react-icons/fa";
import { RiText } from "react-icons/ri";

const UpdateProfile = () => {
  const [isLoading, setisLoading] = useState(true);
  const [bio, setBio] = useState("");
  const [currentBio, setCurrentBio] = useState("");
  const [image, setImage] = useState("");
  const [banner, setBanner] = useState("");
  const data = JSON.parse(sessionStorage.getItem("creatordata"));

  const userImage = data.image;
  const userBanner = data.banner;
  const getData = async () => {
    var response = await getBio(data.email);
    setBio(response);
    setCurrentBio("");
    setisLoading(false);
  };

  const captureImage = (e) => {
    setImage(e.target.files[0]);
  };
  const captureBanner = (e) => {
    setBanner(e.target.files[0]);
  };

  const updateBio = async () => {
    setisLoading(true);
    var jdata = { email: data.email, bio: currentBio };
    await updateBioCreator(jdata);
    getData();
  };

  useEffect(() => {
    getData();
  }, []);

  const updateLocalImage = async (e) => {
    e.preventDefault();
    if (image.size > 0) {
      setisLoading(true);
      let formData = new FormData();
      formData.append("image", image);
      await updateCreatorImage(data.email, formData);
      sessionStorage.removeItem("creatordata");
      var newData = await getSpecificCreator(data.email);
      sessionStorage.setItem("creatordata", JSON.stringify(newData));
      setisLoading(false);
    }
  };
  const updateLocalBanner = async (e) => {
    e.preventDefault();
    if (banner.size > 0) {
      setisLoading(true);
      let formData = new FormData();
      formData.append("banner", banner);
      await updateCreatorBanner(data.email, formData);
      sessionStorage.removeItem("creatordata");
      var newData = await getSpecificCreator(data.email);
      sessionStorage.setItem("creatordata", JSON.stringify(newData));
      setisLoading(false);
    }
  };

  return (
    <>
      {isLoading && (
        <center className="py-20 my-20">
          <FaSpinner icon="spinner" className="spinner" size={70} />
        </center>
      )}
      {!isLoading && (
        <center className="bg py-12">
        <div className="w-96 " >
          <div>
            <img
              className="rounded-full w-10 h-10 border-4"
              src={"" + userImage}
              alt=""
            />
            <div className="">
              <form
                className="flex flex-col gap-5"
                method="post"
                action={updateLocalImage}
              >
                <div className="w-full flex flex-col gap-2">
                  <label htmlFor="image">Profile Image</label>
                  <input
                    required
                    type="file"
                    name="image"
                    id="image"
                    accept=".png"
                    onChange={captureImage}
                    className="w-full border border-gray-400 px-3 py-2 rounded-lg focus:outline-none focus:border-blue-600"
                  />
                </div>

                <button
                  type="submit"
                  value="submit form"
                  className="w-full hover:cursor-pointer text-center bg-blue-600 text-white py-2 rounded-lg"
                  onClick={updateLocalImage}
                >
                  Add Image
                </button>
              </form>
            </div>
          </div>

          {/* banner */}
          <div className="mt-12">
            <img
              className=" w-30 h-20 border-4"
              src={"" + userBanner}
              alt=""
            />
            <div className="">
              <form
                className="flex flex-col gap-5"
                method="post"
                action={updateLocalBanner}
              >
                <div className="w-full flex flex-col gap-2">
                  <label htmlFor="image">Banner</label>
                  <input
                    required
                    type="file"
                    name="image"
                    id="image"
                    accept=".png"
                    onChange={captureBanner}
                    className="w-full border border-gray-400 px-3 py-2 rounded-lg focus:outline-none focus:border-blue-600"
                  />
                </div>

                <button
                  type="submit"
                  value="submit form"
                  className="w-full hover:cursor-pointer text-center bg-blue-600 text-white py-2 rounded-lg"
                  onClick={updateLocalBanner}
                >
                  Add Banner
                </button>
              </form>
            </div>
          </div>
          <div className="mt-12">
            <div>bio :{bio}</div>
            <div>
              <form className="w-full flex flex-col gap-2.5 font-semibold md:w-3/5 lg:w-1/2">
                {/* Account Number Input Section */}
                <div className="flex flex-col gap-1">
                  <label className="text-white" htmlFor="phone">
                    New Bio:
                  </label>
                  <div className="rounded-lg flex items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-1.5 md:gap-4 bg-white text-xs md:text-base">
                    <span>
                      <RiText />
                    </span>
                    <input
                      type="text"
                      name="bio"
                      placeholder="Enter your Bio"
                      className="w-full h-full outline-none"
                      onChange={(e) => {
                        setCurrentBio(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="flex justify-center items-center mt-5">
                  <button
                    className="rounded-full text-center w-full px-4 py-1.5 bg-white text-cyan-700 font-bold"
                    onClick={(e) => {
                      e.preventDefault();
                      if (currentBio.length > 0) {
                        updateBio();
                      }
                    }}
                  >
                    Update Bio
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        </center>
      )}
    </>
  );
};

export default UpdateProfile;
